import React from 'react';
const testimonials = [['JH', 'I mapped out my whole season in one night. Every single practice now has a clear goal, and I walk on knowing exactly what we are doing.', 'James H.', 'Yorkshire, UK'], ['MK', 'My team improved more in two months than in the entire previous season. The attacking progression is exactly what my juniors needed.', 'Mark K.', 'Sydney, Australia'], ['SP', 'I used to spend hours on YouTube hunting for ideas. Now I open Rugby Ready and everything I need for the week is right there.', 'Sunita P.', 'Cape Town, SA'], ['RT', 'The team culture protocols changed everything. My conversations with players are now professional and structured.', 'Richard T.', 'Christchurch, NZ'], ['EW', 'As a first-year coach I was completely overwhelmed. Rugby Ready gave me a full system from day one.', 'Emma W.', 'Manchester, UK'], ['AB', 'The set-piece framework is outstanding. My forwards know exactly what they are doing and why.', 'Arun B.', 'Mumbai, India']];
export function TestimonialsSection() {
  return <section className="bg-white px-5 py-20" data-id="element-220">
      <div className="mx-auto max-w-6xl" data-id="element-221">
        <div className="text-center" data-id="element-222">
          <p className="text-xs font-bold uppercase tracking-[.2em] text-[#d4af37]" data-id="element-223">
            Trusted by coaches everywhere
          </p>
          <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none sm:text-5xl" data-id="element-224">
            What coaches are <span className="text-[#b18b18]" data-id="element-225">saying</span>
          </h2>
          <p className="mt-3 text-sm font-bold text-[#5A5A66]" data-id="element-226">
            ★★★★★ 4.9/5 · 500+ coaches worldwide
          </p>
        </div>
        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-227">
          {testimonials.map(([initials, quote, name, location]) => <figure key={name} className="flex min-h-[250px] flex-col border border-[#E5E5EA] bg-[#FAFAFA] p-6" data-id="element-228">
              <div className="flex items-center gap-3" data-id="element-229">
                <span className="grid h-10 w-10 place-items-center rounded-full bg-[#0A0A0A] text-xs font-bold text-white" data-id="element-230">
                  {initials}
                </span>
                <span className="text-[#d4af37]" aria-label="5 out of 5 stars" data-id="element-231">
                  ★★★★★
                </span>
              </div>
              <blockquote className="mt-5 flex-1 text-sm font-medium italic leading-relaxed text-[#0A0A0A]" data-id="element-232">
                “{quote}”
              </blockquote>
              <figcaption className="mt-5" data-id="element-233">
                <p className="text-sm font-bold" data-id="element-234">{name}</p>
                <p className="text-xs font-medium text-[#5A5A66]" data-id="element-235">{location}</p>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}